import type { DsButtonProps } from '@ds/button/DsButton.vue';

export type DsAlertBannerVariant = 'warning' | 'error' | 'info';

export const DS_ALERT_BANNER_VARIANT_ICONS: Record<DsAlertBannerVariant, string> = {
    warning: 'fa-exclamation-circle',
    error: 'fa-exclamation-triangle',
    info: 'fa-info-circle',
};

export interface DsAlertBannerAction {
    label: string;
    variant: Extract<DsButtonProps['variant'], 'primary' | 'secondary' | 'tertiary'>;
    onClick: () => void;
}

export interface DsAlertBannerProps {
    variant: DsAlertBannerVariant;
    title?: string;
    action?: DsAlertBannerAction;
}
